import ManageEventsApp from "./ManageEventsApp.vue";
import { vueAppWithPinia } from "../Common/vueApp";
import { createEventBus } from "../Common/eventBusFactory";

export const manageEventsAppEventBus = createEventBus();
export const OPEN_MIGRATE_TO_FEDERATION_MODAL = "onOpenMigrateToFederationModal";

export default vueAppWithPinia(ManageEventsApp);
